module.exports = __webpack_public_path__ + "img/undraw-throw-away.cd55cf27.svg";